import { Image, Text } from '@belong/ui';

type Props = {
  description: string;
  image: string;
  title: string;
};

export const WalletFeatureItem = ({ description, image, title }: Props) => (
  <div className="flex flex-col items-center justify-center">
    <Image alt={title} className="mb-xs h-[260px] object-contain" src={image} />
    <Text fontWeight="semibold">{title}</Text>
    <div className="mt-xs max-w-[370px] text-center text-p1 sm:max-w-[495px]">
      <Text dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  </div>
);
